import { gql } from '@apollo/client';

const userLicenseFragment = gql`
  fragment UserLicenseFields on MddapOrganizationUsersInfo {
    OrgUsers {
      key: ExternalUserId
      Email
      Name
      SystemRole {
        DisplayName
      }
      SupplementalRoleId
      AllowedOrgs
      AllowedOrgUnits
      AllowedOhts
      IsSuperUser
      IsDeactivated
      IsFree
    }
    OrgUnitUsers {
      key: ExternalUserId
      Email
      Name
      SystemRole {
        DisplayName
      }
      SupplementalRoleId
      LicensedOrgUnit
      LicensedOrgUnitId
      IsSuperUser
      IsDeactivated
      IsFree
    }
  }
`;

export default userLicenseFragment;
